// extracted by mini-css-extract-plugin
export var hideEditor = "_kw-2";
export var infoIcon = "_kw-3";
export var label = "_kw-1";
export var labelContainer = "_kw-0";
export var readonlyText = "_kw-4";